/**
*
*   Analytics
*       - Send the Analytics
*
**/
'use client';


import useShopifyAnalytics from '@/libraries/shopify/analytics';
import { AnalyticTools } from '@/libraries/analytics';
import { CustomerContext } from '@/context/customer';
import { useSession } from 'next-auth/react';
import { useEffect, useState, useContext } from 'react';
import { usePathname } from 'next/navigation';
import { useLocale } from 'next-intl';
import { useLoadScript } from '@shopify/hydrogen-react';



/**
*
*  Analytics
*       - The Default Script, Analytics send a Page View event on each page load
*
*   Params:
*       payload:        (Object) The payload data to pass to Shopify Analytics
*       track:          (Object) A trackable event, triggered with: { event: (Name of event), data: (The data to pass) }
*
**/
export default function Analytics({ payload , track }){


	//The Session Data
	const { data: session, status } = useSession();


	//Get the Customers
	const { Customer } = useContext(CustomerContext);


	//The Shopify Analtics library
	const ShopifyAnalytics = useShopifyAnalytics();

	//Ready State
	const [ ready , setReady ] = useState(false);

	//Load the Script
	const script = useLoadScript( 'https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js' );

	//Validators
	const pathname = usePathname();
	const locale = useLocale();

	//Initialize Customer Privacy API, Facebook on Customer Changes
	useEffect(()=>{
		if( typeof session != 'undefined' && script === 'done' ){
			(async ()=>{
/*
				//Set the Tracking Consent to True
				window.Shopify.customerPrivacy.setTrackingConsent({
					'analytics':              true,
					'marketing':              true,
					'preferences':            true,
					storefrontAccessToken:    process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
					checkoutRootDomain:       Config.shopify.cookies.checkoutDomain,
					storefrontRootDomain:     Config.shopify.cookies.domain,
					headlessStorefront:       true
					},
					async()=>{}//Do Nothing
				);

				//Load the Cookies
				const cookies = await ShopifyAnalytics.getCookies();

				//Set the Request Cookies
				Storefront.setCookies({
					'Shopify-Storefront-Y': await cookies.y,
					'Shopify-Storefront-S': await cookies.s
				});

				//Apply the Cookies
				AnalyticTools.setCookies(cookies);

				//Initialize the Facebook Query
				Customer.get( customer => AnalyticTools.init( customer ) );
*/
				//Set it as ready
				setReady(true);

			})();
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	},[session, script]);


	//On Page Changes
	useEffect(()=>{
		if( typeof session != 'undefined' && ready ){

			//Send the PageView on load
			ShopifyAnalytics.sendPageView({
				payload:    payload,
				locale:     locale
			});

			//Send the Page View
			AnalyticTools.pageView();

		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	},[pathname, locale, session, ready]);


}



//Export Helper Functions
export { AnalyticTools };